export default {
  header: "Bestellübersicht",
  table: {
    add_table_number: "Tischnummer hinzufügen",
  },
  buttons: {
    checkout: "Zur Kasse",
    continue: "Weiter",
  },
  empty_order_basket: {
    description: "Dein Warenkorb ist leer <br/> Artikel hinzufügen, um loszulegen",
  },
};
